import React from "react";
import { TeacherCoursesCard } from "./TeacherCoursesCard";
import { TeacherCoursesUIProvider } from "./TeacherCoursesUIContext";

export function TeacherCoursesPage({ history }) {
  const teacherCoursesUIEvents = {
    openNewSectionPage: () => {
      history.push("/ogretmen-dersleri/sinif-ve-ders-secme");
    }
  };
  
  return (
    <TeacherCoursesUIProvider teacherCoursesUIEvents={teacherCoursesUIEvents}>
      <TeacherCoursesCard />
    </TeacherCoursesUIProvider>
 );
}